import { EllipsisIcon } from 'lucide-react'

export const OAuthNeutral = () => (
  <>
    <div className="mt-auto w-min rounded-full border-2 border-gray-8 bg-gray-2 p-6">
      <EllipsisIcon className="h-16 w-16 text-gray-9" />
    </div>
    <span className="mt-6 text-lg text-gray-11">Hold on!</span>
  </>
)
